<template>
  <div class="comment-answer loadmore-box">
    <div class="box-user">
      <div class="box-user-img">
        <ImageWrapper v-if="replay._embedded.User.idPicture" :file="replay._embedded.User.idPicture"></ImageWrapper>
        <img v-else src="../../assets/images/avatar-placeholder.png">
      </div>
      <div>
        <span class="box-user-name">{{ replay._embedded.User.name }}</span>
        <span class="box-user-email"> {{ replay._embedded.User.email }}</span>
      </div>
    </div>

    <div class="comment-content"> {{replay.commentText | decodeUnicode}}</div>

    <span class="label" v-if="replay.attachments && replay.attachments.length">Attachments</span>

    <div class="attachment-box" v-for="(attachment, i) in replay.attachments" :key="i" v-bind:class="attachmentClassDirectory(attachment.file_type)">
      <div>
        <span class="attachment-box-name">{{attachment.file_name}}</span>
        <span class="attachment-box-size">{{attachment.file_size}}</span>
      </div>
      <a class="attachment-box-show" target="_blank" :href="attachment.url"></a>
    </div>

    <Gallery v-if="replay.idFile" :gallery="[{idFile: replay.idFile}]" />

    <span class="box-date">{{replay.createdAt | timeSince(replay.createdAtTimezone)}}</span>
  </div>
</template>

<script>
import Gallery from "@/components/general/Gallery";
import ImageWrapper from "@/components/general/ImageWrapper";
export default {
  props: ['replay'],
  name: "CommentAnswer",
  components: {ImageWrapper, Gallery},
  methods: {
    attachmentClassDirectory(type) {
      switch (type) {
        case 'image/jpeg':
        case 'image':
        case 'image/png':
        case 'image/gif':
          return 'attachment-box--pic'
        case 'application/pdf':
        case 'pdf':
          return 'attachment-box--pdf'
        case 'document':
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessing':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
          return 'attachment-box--word'
      }
      return 'attachment-box--default'
    },
  }
}
</script>

<style scoped>

</style>
